var render = function render(){var _vm=this,_c=_vm._self._c;return _c('picture',[_vm._l((_vm.sources),function(source){return _c('source',{key:source.media,attrs:{"media":`(max-width: ${source.maxWidth}px)`,"srcset":source.srcset}})}),_c('img',{style:(_vm.imgStyle),attrs:{"src":_vm.defaultSrc,"alt":_vm.alt},on:{"load":_vm.onLoad}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }